export enum GamePlatFormEnum {
  GP0 = 'GP0',
  GP1 = 'GP1',
  GP2 = 'GP2'
}

export const HOT = 'HOT';

export const defaultText = '--';
